import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Typography,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import moment from "moment";
import { Pagination } from "@material-ui/lab";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import { Select, TextInput } from "../../components/Form";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import TransferDialog from "./TransferDialog";
import { propertyDataArray } from "../../components/PropertyDataArray";
import { useAlert } from "../../components/Alert";

const GET_CUSTOMERCENTERS = gql`
  query customers(
    $admin: Boolean
    $searchTerm: String
    $franchiseStoreId: Int
    $salespersonId: Int
    $customerType: CustomerType
    $customerSource: CustomerSource
    $assignStatus: AssignStatus
    $customerStatus: String
    $missed: Boolean
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    customers(
      admin: $admin
      searchTerm: $searchTerm
      franchiseStoreId: $franchiseStoreId
      salespersonId: $salespersonId
      customerType: $customerType
      customerSource: $customerSource
      customerStatus: $customerStatus
      assignStatus: $assignStatus
      missed: $missed
      latest: $latest
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        franchiseStore {
          id
          name
        }
        salesperson {
          id
          fullName
        }
        trackRecords {
          id
          date
          content
        }
        customerType
        source
        customerStatus
        assignStatus
        unassignedSalespersonId
        customerInfo {
          id
          fullName
          mobile1
          mobile2
        }
      }
    }
  }
`;
const GET_FRANCHISESTORES = gql`
  query franchiseStores($latest: Boolean, $pageSize: Int, $page: Int) {
    franchiseStores(latest: $latest, pageSize: $pageSize, page: $page) {
      contents {
        id
        name
      }
    }
  }
`;

const GET_USERS = gql`
  query users(
    $latest: Boolean
    $identity: Identity
    $pageSize: Int
    $page: Int
  ) {
    users(
      latest: $latest
      identity: $identity
      pageSize: $pageSize
      page: $page
    ) {
      contents {
        id
        fullName
      }
    }
  }
`;

const ASSIGNCUSTOMER = gql`
  mutation assignCustomer($id: Int!) {
    assignCustomer(id: $id)
  }
`;

const MERGE_CUSTOMER = gql`
  mutation mergeCustomer($ids: [Int!]!) {
    mergeCustomer(ids: $ids)
  }
`;
export default function CustomerCenterTable({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  const {
    customerAttributesAllArray,
    customerSourceAllArray,
    assignStatusArray,
    foreclosureSelectAllStatusArray,
    franchiseeSelectAllStatusArray,
  } = propertyDataArray();
  const [ids, setIds] = useState([]);
  const [newData, setNewData] = useState({
    open: false,
    franchiseStoreArray: [],
    franchiseStoreObject: {},
    salespersonArray: [],
    salespersonObject: {},
    customerTypeObject: {
      label: "全部",
      value: null,
    },

    customerSourceObject: {
      label: "全部",
      value: null,
    },
    assignStatusObject: {
      label: "全部",
      value: null,
    },
    clientStatusObject: {
      label: "全部",
      value: null,
    },
    searchTerm: "",
    franchise: false,
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
    DocumentContainerTextEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();
  const {
    data,
    refetch,
    loading: loading,
  } = useQuery(GET_CUSTOMERCENTERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      admin: JSON.parse(localStorage.getItem("@fullhouseAdmin")),
      searchTerm: newData.searchTerm,
      franchiseStoreId: newData.franchiseStoreObject.value,
      salespersonId: newData.salespersonObject.value,
      customerType: newData.customerTypeObject.value,
      customerSource: newData.customerSourceObject.value,
      customerStatus: newData.clientStatusObject.value,
      assignStatus: newData.assignStatusObject.value,
      missed: false,
      latest: true,
      pageSize: 10,
      page: newData.page,
    },
    onCompleted({ customers }) {
      // console.log(customers);
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  const { loading: franchiseStoresLoading } = useQuery(GET_FRANCHISESTORES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      pageSize: 999,
      page: 1,
    },
    onCompleted({ franchiseStores }) {
      if (franchiseStores) {
        let newArray = [];
        franchiseStores.contents.map((item) => {
          newArray.push({ label: item.name, value: item.id });
        });
        changeData("franchiseStoreArray", newArray, true);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  const { loading: usersLoading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      identity: "STAFF",
      pageSize: 999,
      page: 1,
    },
    onCompleted({ users }) {
      if (users) {
        let newArray = [{ label: "全部", value: null }];
        users.contents.map((item) => {
          newArray.push({ label: item.fullName, value: item.id });
        });
        changeData("salespersonArray", newArray, true);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  const [mergeCustomer, { loading: mergeCustomerLoading }] = useMutation(
    MERGE_CUSTOMER,
    {
      onCompleted({ mergeCustomer }) {
        if (mergeCustomer) {
          Alert.notice("合併成功！");
          setIds([]);
          return refetch();
        } else return Alert.notice("合併失敗！");
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  const [assignCustomer, { loading: assignCustomerLoading }] = useMutation(
    ASSIGNCUSTOMER,
    {
      onCompleted({ assignCustomer }) {
        if (assignCustomer) {
          Alert.notice("加入成功！");
          return refetch();
        } else return Alert.notice("加入失敗！");
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );

  function merge() {
    mergeCustomer({ variables: { ids } });
  }

  useEffect(() => {}, [newData.customerTypeObject]);
  if (
    loading ||
    franchiseStoresLoading ||
    usersLoading ||
    mergeCustomerLoading ||
    assignCustomerLoading
  ) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={1}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                分店選擇
              </Typography>
              <Select
                items={newData.franchiseStoreArray}
                value={newData.franchiseStoreObject}
                onChange={(e, value) => {
                  if (value) {
                    if (value.value !== "總店") {
                      changeData("franchise", true);
                      changeData("franchiseStoreObject", value, true);
                    } else {
                      changeData("franchise", false);
                      changeData("franchiseStoreObject", value, true);
                    }
                  } else {
                    changeData("franchiseStoreObject", {}, true);
                  }
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                業務選擇
              </Typography>
              <Select
                items={newData.salespersonArray}
                value={newData.salespersonObject}
                onChange={(e, value) => {
                  if (value) changeData("salespersonObject", value, true);
                  else changeData("salespersonObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶屬性
              </Typography>
              <Select
                items={customerAttributesAllArray}
                value={newData.customerTypeObject}
                onChange={(e, value) => {
                  if (value) {
                    changeData("clientStatusObject", {
                      label: "全部",
                      value: null,
                    });
                    changeData("customerTypeObject", value, true);
                  } else {
                    changeData("clientStatusObject", {
                      label: "全部",
                      value: null,
                    });
                    changeData("customerTypeObject", {}, true);
                  }
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶來源
              </Typography>
              <Select
                items={customerSourceAllArray}
                value={newData.customerSourceObject}
                onChange={(e, value) => {
                  if (value) changeData("customerSourceObject", value, true);
                  else changeData("customerSourceObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                經營狀態
              </Typography>
              <Select
                items={assignStatusArray}
                value={newData.assignStatusObject}
                onChange={(e, value) => {
                  if (value) changeData("assignStatusObject", value, true);
                  else changeData("assignStatusObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                客戶狀態
              </Typography>
              <Select
                items={
                  newData.customerTypeObject.value === null &&
                  newData.customerTypeObject.value === "SERVICE_AREA"
                    ? []
                    : newData.customerTypeObject.value === "FORECLOSURE"
                    ? foreclosureSelectAllStatusArray
                    : franchiseeSelectAllStatusArray
                }
                value={newData.clientStatusObject}
                onChange={(e, value) => {
                  if (value) changeData("clientStatusObject", value, true);
                  else changeData("clientStatusObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                關鍵字
              </Typography>
              <TextInput
                value={newData.searchTerm}
                onChange={(v) => {
                  changeData("searchTerm", v, true);
                }}
                fullWidth
              />
            </Grid>
          </Grid>
          {"\u2002"}
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item classes={{ root: classes.DocumentContainerButtonEnd }}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onPress={merge}
                disabled={ids.length == 0}
              >
                合併客戶
              </Button>
            </Grid>
            <Grid item classes={{ root: classes.DocumentContainerButtonEnd }}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onPress={() => {
                  changeData("open", true, true);
                }}
                disabled={ids.length == 0}
              >
                批次轉移客戶
              </Button>
            </Grid>
            <Grid item classes={{ root: classes.DocumentContainerButtonEnd }}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onPress={() => {
                  onChangeSelect();
                }}
              >
                新增客戶
              </Button>
            </Grid>
          </Grid>
          {newData.franchise ? (
            <Table
              data={data?.customers.contents}
              tableWidth={2}
              header={[
                "",
                "姓名",
                "聯絡電話",
                "追蹤紀錄",
                "追蹤日期",
                "客戶狀態",
                "業務",
              ]}
              columns={[
                (item) => (
                  <Checkbox
                    checked={Boolean(ids.find((item2) => item2 === item.id))}
                    onClick={(event) => {
                      event.stopPropagation();
                      const hasId = ids.find((item2) => item2 === item.id);
                      if (hasId) setIds((e) => e.filter((i) => i !== item.id));
                      else setIds((e) => [...e, item.id]);
                    }}
                  />
                ),
                (item) =>
                  item.customerInfo.map((item2) => {
                    return item2.fullName + "\n";
                  }),
                (item) =>
                  item.customerInfo.map((item2) => {
                    return item2.mobile1 + "\n" + item2.mobile2 + "\n";
                  }),
                (item) =>
                  item.trackRecords[item.trackRecords.length - 1]?.content,
                (item) =>
                  item.trackRecords.length > 0
                    ? moment(
                        item.trackRecords[item.trackRecords.length - 1]?.date
                      ).format("yyyy-MM-DD")
                    : null,
                (item) =>
                  assignStatusArray.find(
                    (item2) => item2.value === item.customerStatus
                  ).label,
                (item) => item.salesperson?.fullName,
              ]}
              onPress={(item) => {
                onChangeSelect(item);
              }}
            />
          ) : (
            <Table
              data={data?.customers.contents}
              tableWidth={2}
              header={[
                "",
                "客戶屬性",
                "客戶來源",
                "姓名",
                "聯絡電話",
                "追蹤紀錄",
                "追蹤日期",
                "經營",
                "客戶狀態",
                "業務",
                "操作",
              ]}
              columns={[
                (item) => (
                  <Checkbox
                    checked={Boolean(ids.find((item2) => item2 === item.id))}
                    onClick={(event) => {
                      event.stopPropagation();
                      const hasId = ids.find((item2) => item2 === item.id);
                      if (hasId) setIds((e) => e.filter((i) => i !== item.id));
                      else setIds((e) => [...e, item.id]);
                    }}
                  />
                ),
                (item) =>
                  customerAttributesAllArray.find(
                    (item2) => item2.value === item.customerType
                  ).label,
                (item) =>
                  customerSourceAllArray.find(
                    (item2) => item2.value === item.source
                  ).label,
                (item) =>
                  item.customerInfo.map((item2) => {
                    return item2.fullName + "\n";
                  }),
                (item) =>
                  item.customerInfo.map((item2) => {
                    return `${item2.mobile1 + "\n"}${
                      item2.mobile2 ? item2.mobile2 + "\n" : "\n"
                    }`;
                  }),
                (item) =>
                  item.trackRecords[item.trackRecords.length - 1]?.content,
                (item) =>
                  item.trackRecords.length > 0
                    ? moment(
                        item.trackRecords[item.trackRecords.length - 1]?.date
                      ).format("yyyy-MM-DD")
                    : null,
                (item) =>
                  assignStatusArray.find(
                    (item2) => item2.value === item.assignStatus
                  ).label,
                (item) =>
                  item.customerType !== "SERVICE_AREA" &&
                  item.customerType === "FORECLOSURE"
                    ? foreclosureSelectAllStatusArray.find(
                        (item2) => item2.value === item.customerStatus
                      )?.label
                    : franchiseeSelectAllStatusArray.find(
                        (item2) => item2.value === item.customerStatus
                      )?.label,
                (item) => item.salesperson?.fullName,
                (item) =>
                  item.unassignedSalespersonId && (
                    <Button
                      variant="contained"
                      color="primary"
                      onPress={(e) => {
                        e.stopPropagation();
                        Alert.alert("通知", "確定要加入？", [
                          {
                            text: "確定",
                            onPress: () => {
                              assignCustomer({
                                variables: { id: item.id },
                              });
                            },
                            type: "ok",
                          },
                          {
                            text: "取消",
                            type: "cancel",
                          },
                        ]);
                      }}
                    >
                      加入
                    </Button>
                  ),
              ]}
              onPress={(item) => {
                onChangeSelect(item);
              }}
            />
          )}
          <TransferDialog
            id={ids}
            open={newData.open}
            onClose={(v) => {
              if (v === "refetch") refetch();
              setIds([]);
              changeData("open", false, true);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.customers.pageCount
                  ? data.customers.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
